import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"

import { Horizontal } from "@/components/Flex.ts"
import { isNotNull } from "@/lib/std.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { DiffLineType } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const LineGutterComponent = observer((props: {
  type: DiffLineType | null
  width: IObservableValue<Property.Width>
  oldLineNum: number | null
  newLineNum: number | null

  theme: (lineType: DiffLineType | undefined | null) => Property.BackgroundColor
}) => {
  return (
    <Container backgroundColor={props.theme(props.type)} width={props.width.get()}>
      <LineGutter>
        <LineGutterSlot>
          {props.oldLineNum}
        </LineGutterSlot>

        {isNotNull(props.newLineNum) &&
          <LineGutterSlot>{props.newLineNum}</LineGutterSlot>
        }
      </LineGutter>
    </Container>
  )
})

export const Container = styled.div<{ backgroundColor: Property.BackgroundColor, width: Property.Width }>`
  ${textStyles.monospaceFont};

  position: sticky;
  left: 0;

  flex-shrink: 0;
  justify-content: flex-end;

  width: ${props => props.width};
  min-width: 35px;

  color: var(--text-color-30);
  background-color: ${props => props.backgroundColor};

  user-select: none;
`

const LineGutter = styled(Horizontal)`
  flex: 0 0 auto;
  justify-content: space-between;

  width: 100%;

  user-select: none;
`

const LineGutterSlot = styled.div<{ lineNumber?: number }>`
  align-items: flex-start;

  width: 50%;
  padding-left: 10px;
`